<template>
  <div id="app">
    <Header v-if="$route.meta.showTitle"/>
    <router-view></router-view>
    <Footer  v-if="$route.meta.showTitle"/>
  </div>
</template>

<script>
import Header from "@/components/MainHead.vue";
import Footer from "@/components/MainFooter.vue";
export default {
  name: "App",
  components: {
    Header,
    Footer,
  },
};
</script>

<style>
* {
  -webkit-user-select: none; /* Safari */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* IE/Edge */
  user-select: none; /* 标准语法 */
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
